import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import { withRouter } from 'react-router-dom'

// Material UI
import { withTheme, withStyles } from '@material-ui/core/styles'
import { TextField, Button, Typography } from '@material-ui/core'
import Snackbar from '@material-ui/core/Snackbar'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'

// Utils
import Utils from '../resources/Utils'
import { requestRecoveryPassword } from '../actions/actions'

const styles = theme => ({
  loginForm: {
    margin: '0 auto',
    marginTop: 16,
    backgroundColor: theme.palette.background.secondary,
    padding: "16px 32px"
  },
  textField: {
    width: '100%',
    marginTop: 8
  },
  loginButton: {
    width: '100%',
    marginTop: 16,
    fontWeight: 600,
    fontSize: 14
  },
  containerFooter: {
    marginTop: 32,
    textAlign: 'center'
  }
})

class RecoveryPasswordForm extends Component {
  constructor(props) {
    super(props)
    
    this.state = {
      snackbar: {
        open: false,
        message: ''
      },
      email: ''
    }

    this.handleClose = this.handleClose.bind(this)
    this.recovery = this.recovery.bind(this)
    this.handleChangeEmail = this.handleChangeEmail.bind(this)
    this.handleKeyPress = this.handleKeyPress.bind(this)
  }

  handleClose() {
    this.setState({
      snackbar: {
        open: false,
        message: this.state.snackbar.message
      }
    })
  }

  recovery() {
    let email = this.state.email.trim()
    if (email === "") {
      this.setState({
        snackbar: {
          open: true,
          message: Utils.getMessages().RecoveryPassword.emailRequired
        }
      })
    }
    else {
      if (!Utils.validateEmail(email)) {
        this.setState({
          snackbar: {
            open: true,
            message: Utils.getMessages().RecoveryPassword.invalidEmail
          }
        })
      }
      else {
        this.props.requestRecoveryPassword({
          email: this.state.email
        })
      }
    }
  }

  componentDidUpdate(prevProps) {
    // Se agrega funcionalidad para validar existencia de correo
      //console.log( this.props.init.recoveryPassword);
      if (prevProps.init.recoveryPassword !== this.props.init.recoveryPassword) {
        if (this.props.init.recoveryPassword.status === "OK") {
          this.setState({
            email: '',
            snackbar: {
              open: true,
              message: Utils.getMessages().RecoveryPassword.emailSended
            }
          })
        }else if(this.props.init.recoveryPassword.status === "WARNING"){
          this.setState({
            email:'',
            snackbar: {
              open: true,
              message: Utils.getMessages().RecoveryPassword.badService
            }
          })
        }else if(this.props.init.recoveryPassword.status === "ERROR"){
          this.setState({
            email:'',
            snackbar: {
              open: true,
              message: Utils.getMessages().RecoveryPassword.emailNotRegistered
            }
          })
        }            
      }
    //

    if (prevProps.init.user !== this.props.init.user) {
      if (this.props.init.user.status === "OK") {
        this.props.history.push('/cuentas')
      }
      else if (this.props.init.user.status === "WARNING") {
        this.setState({
          snackbar: {
            open: true,
            message: Utils.getMessages().LoginForm.loginFormValidation
          }
        })
      }
      else {
        if (!Utils.isEmpty(this.props.init.user)) {
          this.setState({
            snackbar: {
              open: true,
              message: Utils.getMessages().General.error
            }
          })
        }
      }
    }
  }

  handleChangeEmail(event) {
    this.setState({ email: event.target.value })
  }

  handleKeyPress(event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      this.recovery()
    }
  }
  
  render() {
    const { snackbar: { open, message } } = this.state
    const { classes } = this.props

    return (
      <form className={classes.loginForm} noValidate autoComplete="off" onKeyPress={this.handleKeyPress}>
        <TextField
          label={Utils.getMessages().RecoveryPassword.placeholderEmail}
          type="email"
          value={this.state.email}
          onChange={this.handleChangeEmail}
          className={classes.textField}
          autoFocus
        />
        {
          (this.props.init.config.data) ?
            <Button
              variant="contained"
              color="primary"
              className={classes.loginButton}
              onClick={() => { this.recovery() }}
            >
              {Utils.getMessages().RecoveryPassword.confirmButton}
            </Button>
            :
            ''
        }
        <div className={classes.containerFooter}>
          <Link to={{pathname: Utils.constants.paths.login}}>
            <Typography color="primary" variant="body2">{Utils.getMessages().RecoveryPassword.loginButton}</Typography>
          </Link>
          {
            (!Utils.isEmpty(this.props.init.config.data)) ?
              (this.props.init.config.data.fastFlow === 1) ?
                <div>
                  <br />
                  <Typography variant="body1">{Utils.getMessages().LoginForm.loginMessage}</Typography>
                  <Link to={{pathname: Utils.constants.paths.home}}>
                    <Typography color="primary" variant="body2">{Utils.getMessages().LoginForm.payButton}</Typography>
                  </Link>
                </div>
              :
              ''
            :
            ''
          }
          <Typography variant="body1">-</Typography>
          <Link to={{pathname: Utils.constants.paths.register}}>
            <Typography color="primary" variant="body2">{Utils.getMessages().RecoveryPassword.registerButton}</Typography>
          </Link>
        </div>
        
        <Snackbar
          autoHideDuration={5000}
          anchorOrigin={{vertical: 'top', horizontal: 'center'}}
          open={open}
          onClose={this.handleClose}
          message={
            <span>
              {message}
            </span>
          }
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={this.handleClose}
            >
              <CloseIcon />
            </IconButton>
          ]}
        />

      </form>
    )
  }
}

const mapStateToProps = state => ({ ...state })

const mapDispatchToProps = dispatch => {
  return {
    requestRecoveryPassword: (data) => {
      dispatch(requestRecoveryPassword(data))
    }
  }
}

export default compose(
  withRouter,
  withTheme,
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(RecoveryPasswordForm)
